import { Typography } from "@material-tailwind/react";
import { t } from "i18next";

/**
 * Composant pour afficher un état vide dans la section des parts
 */
export default function EmptyPartsState() {
  return (
    <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
      <Typography variant="h6" className="text-gray-600 mb-2">
        {t("workorder:parts:noData")}
      </Typography>
    </div>
  );
} 